/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Skeleton, Text } from '@sendible/design-system';
import { Container } from './index.styles';

interface Props {
  onClick: (text: string, image: string) => void;
  holidays: Holiday[];
  isLoading: boolean;
}

export const Holidays = ({ isLoading, holidays, onClick }: Props) =>
  isLoading ? (
    <Skeleton
      width="100%"
      height="0.5rem"
    />
  ) : (
    <Container className="holidays">
      <Text variation="body_12">
        {holidays.map((h) => (
          <span
            data-testid="calendar-holidays"
            key={h.id}
            onClick={() => onClick?.(h.message, h.images[0])}
          >
            {h.message}{' '}
          </span>
        ))}
      </Text>
    </Container>
  );
